import angular from 'angular';

import template from './image-zoom.html';
import './image-zoom.less';

angular.module('myConsultApp').directive('imageZoom', () => {
  return {
    template,
    restrict: 'E',
    transclude: true,
    scope: {
      scale: '=',
    },
    link: ($scope, element) => {
      const overlay = angular.element(element.find('.image-zoom__overlay')[0]);

      if (overlay) {
        const onMouseMove = (evt) => {
          overlay.css({
            'transform-origin':
              ((evt.pageX - overlay.offset().left) / overlay.width()) * 100 +
              '% ' +
              ((evt.pageY - overlay.offset().top) / overlay.height()) * 100 +
              '%',
          });
        };

        const onMouseOver = () => {
          overlay.css({ transform: `scale(${$scope.scale || 2})` });
          element.on('mousemove', onMouseMove);
        };
        const onMouseOut = () => {
          overlay.css({ transform: 'scale(1)' });
          element.off('mousemove', onMouseMove);
        };

        element.on('mouseover', onMouseOver);
        element.on('mouseout', onMouseOut);
      }
    },
  };
});
